export const patternTypes = ['stripes', 'squares', 'rhombus']